/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowCRightIcon20Solid = forwardRef('ArrowCRightIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M6.403 2.778a1.375 1.375 0 0 1 1.944 0L13.36 7.79a3.125 3.125 0 0 1 0 4.42l-5.013 5.012a1.375 1.375 0 1 1-1.944-1.944l5.012-5.013a.375.375 0 0 0 0-.53L6.403 4.722a1.375 1.375 0 0 1 0-1.944Z" })));
});
